import { Action, Toast, ToastState } from "../types/ToastState"

const INITIAL_TOAST_STATE = {}

function makeid(length: number) {
  let result = ""
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
  const charactersLength = characters.length
  let counter = 0
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
    counter += 1
  }
  return result
}

const addToast = (toast: Toast, state: ToastState): ToastState => {
  toast.id = makeid(5)
  const newState = {
    ...state,
    [toast.id]: toast,
  }
  return newState
}

const destroyToast = (id: string, state: ToastState): ToastState => {
  const toasts = Object.values(state) // convert object to array
  const newToasts = toasts.filter((t) => t.id !== id)
  // convert arr to object with custom id attribute
  return newToasts.reduce((a, v) => ({ ...a, [v.id]: v }), {})
}

const initialState: ToastState = INITIAL_TOAST_STATE

const reducer = (state: ToastState, action: Action): ToastState => {
  switch (action.type) {
    case "ADD_TOAST":
      return addToast(action.toast, state)
    case "DESTROY_TOAST":
      return destroyToast(action.id, state)
    default:
      return state
  }
}

export { initialState, reducer }
